import { render, staticRenderFns } from "./ScripticItemPreview.vue?vue&type=template&id=66894f18"
import script from "./ScripticItemPreview.vue?vue&type=script&lang=ts"
export * from "./ScripticItemPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports